import { Role } from "../../data/models.interface"
import useLazyQuery from "../useLazyQuery"

export const useCreateRoleQuery = () => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/roles`
	return useLazyQuery<Role, void>(url, "POST")
}
